import axios from 'axios';

import { attachErrorLogging, attachOktaToken, getAccessToken } from './oktaToken';

const client = axios.create({
  baseURL: '/api',
  timeout: 300000, // 5 minutes - asset uploads can take time
  // Auth is the Okta bearer token attached below; IAP is disabled. Cookies are
  // still sent because this client is same-origin (baseURL '/api'), so it costs
  // nothing and keeps any session cookie the backend sets working.
  withCredentials: true,
});

// Token handling lives in ./oktaToken so the Asset Library client (a different
// origin, same user) shares one OktaAuth instance and one setOktaAuth call site.
attachOktaToken(client);
attachErrorLogging(client);

// Re-exported so existing importers (main.tsx, App.tsx) keep working; the
// instance itself is now held in ./oktaToken.
export { setOktaAuth } from './oktaToken';

// Helper function for authenticated fetch (for blob downloads, etc.)
export const authenticatedFetch = async (
  url: string,
  options: RequestInit = {},
): Promise<Response> => {
  const token = await getAccessToken();
  if (token) {
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    };
  }

  // Same-origin call, so cookies ride along harmlessly. The Authorization
  // header above is what actually authenticates the request.
  return fetch(url, {
    ...options,
    credentials: 'include',
  });
};

export default client;
